// API Configuration for both localhost and production
const getApiUrl = (): string => {
  // Check if we're in development (localhost)
  const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  
  if (isDevelopment) {
    // Development: use localhost
    return 'http://localhost:8000';
  } else {
    // Production: Use the same protocol as the current page
    // This works whether you have HTTPS termination at reverse proxy or direct HTTPS
    const protocol = window.location.protocol; // 'http:' or 'https:'
    const hostname = window.location.hostname; // 'superpossible.ai'
    
    return `${protocol}//${hostname}`;
  }
};

export const API_URL = getApiUrl();

// Artifact Theater Configuration
export const ARTIFACT_CONFIG = {
  BATCH_SIZE: 3, // Number of artifacts to fetch at once
  IMAGE_DURATION: 10000, // Duration to display images (ms)
};

// Export for debugging
export const getDebugInfo = () => ({
  hostname: window.location.hostname,
  isDevelopment: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1',
  apiUrl: API_URL,
  artifactConfig: ARTIFACT_CONFIG
});
